import React from 'react'
import styled from 'styled-components'
import { images } from '../constants'

// styled
const StyledCard = styled.div`
  .card {
    position: relative;
    top: -40px;
    left: 60px;
    width: 300px;
    height: 460px;
    padding: 5px 35px 0 35px;
    border-radius: 10px;
    background-color: var(--grey);
    box-shadow: 0 0 0 1px rgb(0 0 0 / 1%), 0 25px 25px rgb(0 0 0 / 3%), 0 15px 15px rgb(0 0 0 / 6%), 0 10px 8px rgb(0 0 0 / 5%), 0 4px 4px rgb(0 0 0 / 4%), 0 2px 2px rgb(0 0 0 / 3%);
    @media screen and (max-width: 1023px) {
      left: 40px;
    }
    @media screen and (max-width: 800px) {
      display: none;
    }
  }
  .sneaker-card {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 200px;
    height: 200px;
    margin: 0 15px;
    .sneaker-card--circle {
      position: absolute;
      z-index: 1;
      width: 150px;
      height: 150px;
      border-radius: 50%;
      background: rgb(241, 66, 61);
      background: linear-gradient(117deg, rgba(247, 85, 73, 1) 4%, rgba(240, 115, 143, 1) 47%, rgba(56, 97, 156, 1) 94%);
    }
    img {
      z-index: 2;
      animation: 12s ease-in-out -0.5s infinite float-y running;
    }
  }
  .info-card {
    h2 {
      color: var(--grey-hover);
      font-size: var(--fz-lg);
      margin-bottom: 12px;
      text-align: center;
    }
    h3 {
      text-align: center;
      color: var(--grey-medium);
      font-weight: 400;
      font-size: var(--fz-sm);
      margin-bottom: 20px;
      text-transform: uppercase;
    }
    .info-card--sizes {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 10px;
      .info-card--size {
        padding: 6px 14px;
        border: none;
        color: var(--white);
        font-family: var(--font-sans);
        font-size: var(--fz-xs);
        border-radius: 30px;
        background-color: var(--grey-medium);
        &.active {
          background-color: var(--secondary);
        }
      }
    }
    .info-card--purchase {
      position: absolute;
      bottom: 32px;
      .purchase-btn {
        width: 160px;
        margin: 0 35px;
        padding: 12px 0 15px;
        border: none;
        color: var(--white);
        font-family: var(--font-condensed);
        font-size: var(--fz-sm);
        letter-spacing: 0.5px;
        text-align: center;
        font-weight: 500;
        border-radius: 30px;
        box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
        background-color: var(--grey-hover);
      }
    }
  }
  @keyframes float-y {
    0%,
    100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-10px);
    }
  }
`

// markup
const SneakerCard = () => {
  return (
    <StyledCard>
      <div className="card">
        <div className="sneaker-card">
          <div className="sneaker-card--circle"></div>
          <img src={images.sneaker} alt="Sneaker" />
        </div>
        <div className="info-card">
          <h2>Adidas Trainers ZX</h2>
          <h3>Future-ready sneaker with wrapped boost for optimal comfort.</h3>
          <div className="info-card--sizes">
            <div className="info-card--size">38</div>
            <div className="info-card--size">40</div>
            <div className="info-card--size active">42</div>
            <div className="info-card--size">44</div>
          </div>
          <div className="info-card--purchase">
            <div className="purchase-btn">Buy Now!</div>
          </div>
        </div>
      </div>
    </StyledCard>
  )
}

export default SneakerCard
